import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 1600 775"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "url(#i1750614203__a)",
  d: "M1576 0H24C10.745 0 0 10.745 0 24v727c0 13.255 10.745 24 24 24h1552c13.25 0 24-10.745 24-24V24c0-13.255-10.75-24-24-24"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("radialGradient", {
    id: "i1750614203__a",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "matrix(3284.05 0 0 3051.73 476.95 -103.241)",
    gradientUnits: "userSpaceOnUse"
  }, [
    /*#__PURE__*/_createElementVNode("stop", {
      offset: ".12",
      "stop-color": "#E0FFFC"
    }),
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "1",
      "stop-color": "#2FD3C7"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }